import { autoinject, bindable } from 'aurelia-framework';
import { ServiceStructureService, ServiceNodeModel } from "./service-structure-service";
import { Subscription } from 'aurelia-event-aggregator';
import { TabService } from "../../components/tabs/tab-service";
import { NodeModel } from "../../models/node-model";
import { ServiceStructureParser, IStructureParser } from "../../components/structure-import/structure-parsers/structure-parser";

@autoinject
export class ServiceActions {
	@bindable structureId: string;
	@bindable structureName: string;

	@bindable selectedService: ServiceNodeModel;

	nodeClickSubscriber: Subscription;

	serviceStructureParser: IStructureParser<NodeModel[]>

	tabId = "service-structure";
	basicTabId = "basic";
	addTabId = "add";

	@bindable cardTitle: string;

	get isBasicTabActive(): boolean {
		return this.tabService.isActive(this.tabId, this.basicTabId);
	}

	get isAddTabActive(): boolean {
		return this.tabService.isActive(this.tabId, this.addTabId);
	}

	constructor(
		private element: Element,
		private service: ServiceStructureService,
		private tabService: TabService) {

		this.serviceStructureParser = new ServiceStructureParser();
	}

	attached() {
		this.setCardTitle();
		this.tabService.select(this.tabId, this.addTabId);
	}

	setCardTitle() {
		this.cardTitle = this.selectedService ? this.selectedService.title : this.structureName;
	}

	selectedServiceChanged(newValue: ServiceNodeModel, oldValue: ServiceNodeModel): void {
		this.setCardTitle();

		// No previous selection or new selection --> go to basic info tab. Otherwise, do nothing.
		if (!oldValue && newValue) {
			this.tabService.select(this.tabId, this.basicTabId);
			return;
		}

		// No new selection --> go to add tab, this means we're at structure level.
		if (!newValue) {
			this.tabService.select(this.tabId, this.addTabId);
		}
	}

	refreshStructure() {
		this.element.dispatchEvent(new CustomEvent('structure-updated', { bubbles: true }));
	}
}
